import { Tooltip } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { InfoCircleIcon } from "shared/icons/InfoCircleIcon";

export const AllocationMethodologyTitle: React.FC = () => {
  const { t } = useTranslation(["investment"]);
  return (
    <>
      {t("investment:allocationMethodology")}
      <Tooltip
        label={t("investment:allocationMethodologyTooltip")}
        placement="top"
      >
        <InfoCircleIcon w="14px" h="14px" ml="4px" color="gray.400" />
      </Tooltip>
    </>
  );
};
